import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { JackpotDefaultBlock } from "./ui/JackpotDefaultBlock";
import { InitHelpers } from "../../helpers";
import { rootDataRetriever } from "../../data";
if (InitHelpers.isDevEnv()) {
    const mocks = require("../../mocks");
    mocks.SetWindowMocks();
}
export class JackpotDefaultBlockRoot extends BaseBlock {
    constructor(domId, options, config, isAvailableCallbackFn) {
        //constructor should be as simple as possible because 'JackpotDefaultBlock' could be used as ReactNode directly
        super(domId, options);
        this.options.dict = options.dict;
        this.options.cms = options.cms;
        this.config = config;
        this.isAvailableCallbackFn = isAvailableCallbackFn;
    }
    activate() {
        //if block is loaded (broadcastBlockLoad was triggered) but only component is used
        // => we should skip regular activate flow
        if (!Object.keys(this.options.cms).length) {
            return super.activate(React.createElement(React.Fragment, null));
        }
        // no custom logic here because 'JackpotDefaultBlock' could be used as ReactNode directly
        return super.activate(React.createElement(JackpotDefaultBlock, { usedAsPartOfBlock: true, isAvailableCallbackFn: this.isAvailableCallbackFn, cms: this.options.cms, dict: this.options.dict, dataRetriever: rootDataRetriever, config: this.config }));
    }
    deactivate() {
        // no custom logic here because 'JackpotDefaultBlock' could be used as ReactNode directly
        return super.deactivate();
    }
}
window["JackpotDefaultBlock"] = JackpotDefaultBlockRoot;
broadcastBlockLoad("JackpotDefaultBlock");
//# sourceMappingURL=index.js.map